import React from 'react'
import { useNavigate } from 'react-router-dom';

export default function CTA() {
  const navigate = useNavigate();

  return (
     <section className="bg-gradient-to-r from-orange-500 to-red-500 py-16 text-white text-center">
        <h2 className="text-4xl font-black mb-4">Ready to Order? 🍽️</h2>
        <p className="text-orange-100 mb-8">Get 20% off your first order with code WELCOME20</p>
        <button onClick={() => navigate("/menu")} className="bg-white text-orange-500 font-black px-10 py-4 rounded-2xl hover:scale-105 transition-transform shadow-xl">
          Start Ordering Now
        </button>
      </section>
  )
}
